<template src="./paladin-reports.html"></template>

<script>
import PaladinReport from './paladin-report'

  // import PaladinReportEdit from '../../../library/components/reporting/paladin-report-edit'
 import { PaladinReportEdit, } from '@paladin/core-components'

export default {
components: { PaladinReport, PaladinReportEdit, },
  // components: { PaladinReport, },
  props: {
    activeGroup: {
      type: Object,
      required: true,
    },
    allRoles: {
     type: Array,
     default: null
    },
  },
  data() {
    return {
      showReport: false,
      reportData: null,
    }
  },
  computed: {
  },
  watch: {
  },
  created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {
    },
    showData(report)
    {
      this.reportData = report
      this.showReport = true
    },
    loadReport()
    {
      this.reportData = null
      this.showReport = true
    },
    closeReport()
    {
      this.reportData = null
      this.showReport = false
    },
  },
}
</script>

<style lang="scss"></style>
